import { TThunkAction } from '../../types/redux/thunk';
import { deleteFavoriteRequest } from '../../services/favorite';
import { deleteNewbuildingFavoriteSuccess } from './deleteNewbuildingFavoriteActions';
import { addNewbuildingFavoriteSuccess } from './addNewbuildingFavoriteActions';

interface IDeleteNewbuildingFavorite {
  newbuildingId: number;
  label: string;
}

export const deleteNewbuildingFavorite =
  ({ newbuildingId }: IDeleteNewbuildingFavorite): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, httpApi }) => {
    try {
      dispatch(deleteNewbuildingFavoriteSuccess({ newbuildingId }));

      const response = await deleteFavoriteRequest({
        httpApi,
        parameters: {
          entityId: newbuildingId,
          entityType: 'newbuilding',
        },
      });

      const { status } = response || {};

      if (status == null) {
        dispatch(addNewbuildingFavoriteSuccess({ newbuildingId }));
      }
    } catch (error) {
      logger.error(error, {
        newbuildingId,
        domain: 'src/shared/actions/newbuildingFavorite#deleteNewbuildingFavorite()',
        message: error.message,
      });

      dispatch(addNewbuildingFavoriteSuccess({ newbuildingId }));
    }
  };
